import styled from "styled-components";

export const CarouselContainer = styled.div`
	width: calc(100vw - 370px);
	@media screen and (max-width: 767px) {
		width: 100%;
	}
`;
